import { isPoint, equalPoints } from "./functions"

export const comparePoints = (numberDataBase: string, numberUser: string) => {

    const numero = numberDataBase.replace(/ /g,'');
    const numeroUsuario = numberUser.replace(/ /g,'');

    if (numeroUsuario === '') {
        return { 
            ok: null, 
            title: '¡Cuidado!',
            msg: 'No has ingresado una respuesta'
        }
    }

    if (!isPoint(numeroUsuario).ok) {
        return { 
            ok: null, 
            title: '¡Cuidado!',
            msg: 'Tu respuesta no representa un vector'
        }
    }

    if (!equalPoints(numero,numeroUsuario).ok) {
        return { 
            ok: false, 
            title: 'Sigue intentando!',
            msg: 'Tu respuesta no coincide con la solución'
        }
    }

    return { 
        ok: true, 
        title: '¡Felicitaciones!',
        msg: 'Has encontrado la solución'
    }
}
